<template>
  <Card size="large" class="connect-card">
    <View direction="column" gap="md">
      <View direction="column" gap="xs">
        <Text variant="h3">Connect your CodeBox account</Text>
        <Text variant="body-medium" color="secondary">
          Your portal credentials. They're stored encrypted and only used to mint codes for your showings.
        </Text>
      </View>

      <CodeboxConnectForm />
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Card, Text, View } from '@tallo/design-system';
import { CodeboxConnectForm } from '@tallo/investor/property';
</script>

<style scoped lang="scss">
.connect-card {
  max-width: 32rem;
}
</style>
